import { faAngleUp as r, faAngleDown as a, faAngleRight as o, faArrowRight as c, faBars as n, faBullhorn as i, faCircleArrowDown as l, faCheck as f, faCircleArrowUp as t, faCircleExclamation as e, faDownload as w, faXmark as h, faMinus as g } from "@fortawesome/pro-solid-svg-icons";
const p = {
  caratUp: r,
  caratDown: a,
  caretRight: o,
  arrowRight: c,
  bars: n,
  bullhorn: i,
  circleArrowDown: l,
  check: f,
  circleArrowUp: t,
  circleExclamation: e,
  download: w,
  xMark: h,
  minus: g
};
export {
  p as rightIconOptions
};
